import WebsiteServiceModel   from '@/models/WebsiteServiceModel';
import doc                   from '@widesk-core/decorators/doc';
import i18n                  from '@/i18n.config';

export default class StandPageValidationStatusModel extends WebsiteServiceModel {
	private declare _tsFilters: {
		'id': id;
		'partial': string;
	};

	static get path(): string {
		return 'stand_page_validation_statuses/{?id}';
	}

	@doc.string declare name: string;
	@doc.number declare value: number;
	@doc.string declare label: string;
	@doc.string declare reference: Website_StandPageValidationStatusReference;

	get color() {
		switch (this.reference) {
			case 'REFUSED':
				return 'red';
			case 'DISABLED':
				return 'default';
			case 'IN_CREATION':
				return 'blue';
			case 'VALIDATION_REQUESTED':
				return 'orange';
			case 'VALIDATED':
				return 'green';
		}
	}

	getLabel() {
		return i18n.t(`pages.stands.pageValidationStatuses.${this.reference}`);
	}
}
